module.exports = __webpack_public_path__ + "img/38.b4cf7c2a.png";